import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import * as Dati from "src/Dati";
import { Trad } from "src/components/";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";

interface IEconomicDataFormContentProps {
    Data: Dati.CDatiEconomici;
    ID_Anag: number;
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
}

export const _EconomicDataFormContent = ({ Data, ID_Anag, OnChange }: IEconomicDataFormContentProps) => {
    return (
        <Grid container spacing={5}>
            <Grid item xs={12} md={3}>
                <TextField fullWidth id="ID_DatoEconomico" label={Trad.Trad("ID")} value={Data.ID_DatoEconomico} disabled />
            </Grid>
            <Grid item xs={12} md={4}>
                <_Autocomplete Value={Data.ID_Anag ?? ""} Name="ID_Anag" Label="Nominativo" Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" OnChange={OnChange} Disabled={!!ID_Anag} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_DateField Value={Data.Data} Name="Data" Label="Data" OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    fullWidth
                    id="AnnoBilancio"
                    label={Trad.Trad("Anno Bilancio")}
                    value={Data.AnnoBilancio || ""}
                    onChange={OnChange}
                    inputProps={{ type: "number", min: "2000", max: "2099" }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="Fatturato" Label="Fatturato" Value={Data.Fatturato} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="PatrimonioNetto" Label="Patrimonio netto" Value={Data.PatrimonioNetto} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="MargineOperativoLordo" Label="Margine Operativo Lordo" Value={Data.MargineOperativoLordo} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="AttivoCircolante" Label="Attivo circolante" Value={Data.AttivoCircolante} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="DebitiBreve" Label="Debiti a breve" Value={Data.DebitiBreve} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="ValoreProduzioneUltimoAnno" Label="Valore Produzione Ultimo Anno" Value={Data.ValoreProduzioneUltimoAnno} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="ValoreProduzioneAnnoPrecedente" Label="Valore produzione anno precedente" Value={Data.ValoreProduzioneAnnoPrecedente} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="TotalePassivo" Label="Totale passivo" Value={Data.TotalePassivo} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="DebitiOltreBTVersoBanche" Label="DebitiOltreBTVersoBanche" Value={Data.DebitiOltreBTVersoBanche} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="DebitiCorrentiVersoBanche" Label="DebitiCorrentiVersoBanche" Value={Data.DebitiCorrentiVersoBanche} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="AttivitaFinanziarie" Label="AttivitaFinanziarie" Value={Data.AttivitaFinanziarie} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="Liquidita" Label="Liquidita" Value={Data.Liquidita} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="PassivoConsolidato" Label="PassivoConsolidato" Value={Data.PassivoConsolidato} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="PassivoCorrente" Label="PassivoCorrente" Value={Data.PassivoCorrente} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField fullWidth id="Classificazione" label={Trad.Trad("Classificazione")} value={Data.Classificazione} onChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_DateField Value={Data.DataCostituzione} Name="DataCostituzione" Label="DataCostituzione" OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    fullWidth
                    id="NumeroDipendenti"
                    label={Trad.Trad("NumeroDipendenti")}
                    value={Data.NumeroDipendenti}
                    onChange={OnChange}
                    inputProps={{ type: "number", min: 0, className: "numberInput" }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField fullWidth id="AnnoUnico" label={Trad.Trad("Anno Unico")} value={Data.AnnoUnico || ""} onChange={OnChange} inputProps={{ type: "number", min: "2000", max: "2099" }} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="RedditoImmobili" Label="Reddito Immobili" Value={Data.RedditoImmobili} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12} md={3}>
                <_NumberField Id="RedditoComplessivo" Label="Reddito complessivo" Value={Data.RedditoComplessivo} OnChange={OnChange} />
            </Grid>
            <Grid item xs={12}>
                <TextField multiline fullWidth variant="outlined" id="Commenti" label={Trad.Trad("Commenti")} rows={3} rowsMax={5} value={Data.Commenti || ""} onChange={OnChange} />
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/EconomicData/EconomicDataFormContent.tsx